import React, { useState } from 'react';
import { Row, Col } from './Layout';
import { useTranslation } from 'react-i18next';

interface PrivacySecurityModalProps {
    onClose: () => void;
}

export const PrivacySecurityModal: React.FC<PrivacySecurityModalProps> = ({ onClose }) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState<'password' | 'blocked'>('password');

    // Password State
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    // Mock Blocked Users
    const [blockedUsers, setBlockedUsers] = useState([
        { id: 'b1', username: 'toxic_user99', profileImage: '/default-avatar.png' },
        { id: 'b2', username: 'spammer_bot', profileImage: '/default-avatar.png' },
    ]);

    const handleChangePassword = (e: React.FormEvent) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            alert(t('privacy.passwordMatchError', 'Yeni şifreler eşleşmiyor!'));
            return;
        }
        if (newPassword.length < 6) {
            alert(t('privacy.passwordLengthError', 'Şifre en az 6 karakter olmalıdır.'));
            return;
        }
        // TODO: Call API
        alert(t('privacy.passwordSuccess', 'Şifreniz başarıyla değiştirildi! (Simülasyon)'));
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
    };

    const handleUnblock = (id: string) => {
        if (window.confirm(t('privacy.unblockConfirm', 'Bu kullanıcının engelini kaldırmak istediğinize emin misiniz?'))) {
            setBlockedUsers(prev => prev.filter(u => u.id !== id));
            // TODO: Call API
        }
    };

    return (
        <div style={{ position: 'fixed', inset: 0, zIndex: 99999, display: 'flex', flexDirection: 'column' }}>
            <div onClick={onClose} style={{
                position: 'absolute', inset: 0,
                background: 'rgba(0,0,0,0.65)',
                backdropFilter: 'blur(5px)',
                animation: 'overlayIn .3s ease'
            }} />

            <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                background: 'var(--bg)',
                borderTopLeftRadius: 30, borderTopRightRadius: 30,
                borderTop: '1px solid var(--border)',
                height: '85vh', display: 'flex', flexDirection: 'column',
                animation: 'slideUpModal .4s cubic-bezier(0.16, 1, 0.3, 1)'
            }}>
                <div style={{ padding: '20px', borderBottom: '1px solid var(--border)', background: 'var(--surface)', borderTopLeftRadius: 30, borderTopRightRadius: 30 }}>
                    <div style={{ width: 40, height: 4, background: 'var(--border)', borderRadius: 2, margin: '0 auto 15px' }} />
                    <Row style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className="syne" style={{ fontSize: 20, fontWeight: 800, color: 'var(--text)' }}>
                            {t('account.items.privacy', 'Gizlilik ve Güvenlik')}
                        </div>
                        <button onClick={onClose} className="icon-btn" style={{ color: 'var(--text)', background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>✕</button>
                    </Row>
                </div>

                <div style={{ display: 'flex', padding: '16px', gap: '12px', background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
                    <button
                        onClick={() => setActiveTab('password')}
                        style={{
                            flex: 1, padding: '12px', borderRadius: '12px', border: 'none', fontWeight: 700, fontSize: 13, cursor: 'pointer', transition: 'all .2s',
                            background: activeTab === 'password' ? 'var(--primary)' : 'var(--surface2)',
                            color: activeTab === 'password' ? '#fff' : 'var(--muted)'
                        }}
                    >
                        🔑 {t('privacy.changePassword', 'Şifre Değiştir')}
                    </button>
                    <button
                        onClick={() => setActiveTab('blocked')}
                        style={{
                            flex: 1, padding: '12px', borderRadius: '12px', border: 'none', fontWeight: 700, fontSize: 13, cursor: 'pointer', transition: 'all .2s',
                            background: activeTab === 'blocked' ? '#FF5555' : 'var(--surface2)',
                            color: activeTab === 'blocked' ? '#fff' : 'var(--muted)'
                        }}
                    >
                        🚫 {t('privacy.blockedUsers', 'Engellenenler')} {blockedUsers.length > 0 && `(${blockedUsers.length})`}
                    </button>
                </div>

                <div style={{ flex: 1, overflowY: 'auto', padding: '24px 20px', color: 'var(--text)' }}>
                    {activeTab === 'password' && (
                        <form onSubmit={handleChangePassword} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            <div>
                                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--muted)', marginBottom: 8 }}>
                                    {t('privacy.currentPassword', 'Mevcut Şifre')}
                                </label>
                                <input
                                    type="password"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    placeholder="••••••••"
                                    required
                                    style={{ width: '100%', padding: '14px', borderRadius: '12px', border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text)', outline: 'none', fontSize: 15 }}
                                />
                            </div>
                            <div>
                                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--muted)', marginBottom: 8 }}>
                                    {t('privacy.newPassword', 'Yeni Şifre')}
                                </label>
                                <input
                                    type="password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    placeholder="••••••••"
                                    required
                                    style={{ width: '100%', padding: '14px', borderRadius: '12px', border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text)', outline: 'none', fontSize: 15 }}
                                />
                            </div>
                            <div>
                                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--muted)', marginBottom: 8 }}>
                                    {t('privacy.confirmPassword', 'Yeni Şifre (Tekrar)')}
                                </label>
                                <input
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="••••••••"
                                    required
                                    style={{ width: '100%', padding: '14px', borderRadius: '12px', border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text)', outline: 'none', fontSize: 15 }}
                                />
                            </div>
                            <button type="submit" style={{ width: '100%', padding: '16px', borderRadius: '14px', border: 'none', background: 'var(--primary)', color: '#fff', fontSize: 16, fontWeight: 700, marginTop: '10px', cursor: 'pointer' }}>
                                {t('privacy.updatePasswordBtn', 'Şifreyi Güncelle')}
                            </button>
                        </form>
                    )}

                    {activeTab === 'blocked' && (
                        <div>
                            {blockedUsers.length === 0 ? (
                                <div style={{ textAlign: 'center', padding: '40px 20px', color: 'var(--muted)' }}>
                                    <div style={{ fontSize: 48, marginBottom: 16 }}>🛡️</div>
                                    <div style={{ fontSize: 16, fontWeight: 600 }}>{t('privacy.noBlocked', 'Engellenen kimse yok')}</div>
                                    <div style={{ fontSize: 13, marginTop: 8 }}>{t('privacy.noBlockedDesc', 'Uygulamada engellediğiniz kullanıcılar burada görünür.')}</div>
                                </div>
                            ) : (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                    {blockedUsers.map(user => (
                                        <div key={user.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'var(--surface)', padding: '12px 16px', borderRadius: '14px', border: '1px solid var(--border)' }}>
                                            <Row style={{ gap: 12, alignItems: 'center' }}>
                                                <img src={user.profileImage} alt="" style={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover' }} />
                                                <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text)' }}>
                                                    {user.username}
                                                </div>
                                            </Row>
                                            <button onClick={() => handleUnblock(user.id)} style={{ background: 'var(--surface2)', color: 'var(--text)', border: 'none', padding: '8px 14px', borderRadius: '8px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                                                {t('privacy.unblockBtn', 'Kaldır')}
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
